export enum FormListItemBadgeVariant {
  High = "high",
  Low = "low",
  Task = "task",
}
